import { Camera } from "lucide-react";
import { SectionBadge } from "./Shared";
import { useScrollReveal } from "../lib/hooks";
import { FONT_HEAD, FONT_BODY, NAVY, GOLD } from "../lib/constants";

const COPY = {
  en: {
    badge: "Photo Report After Every Clean",
    title: "You don't have to be home to know it was done right.",
    body: [
      "After every clean, you get a photo report — before and after, room by room. Open it from your phone in Michigan, or between flights, and see exactly how your home was left.",
      "And if we ever find something damaged or broken, you hear it from us first, with photos. No surprises, no quiet fixes, no wondering.",
    ],
    quote: "Most cleaning companies ask you to trust them. We'd rather just show you.",
  },
  es: {
    badge: "Reporte fotográfico tras cada limpieza",
    title: "No tienes que estar en casa para saber que quedó bien hecho.",
    body: [
      "Después de cada limpieza recibes un reporte fotográfico — antes y después, habitación por habitación. Ábrelo desde tu teléfono en Michigan o entre vuelos, y mira exactamente cómo quedó tu casa.",
      "Y si alguna vez encontramos algo dañado o roto, te lo decimos nosotros primero, con fotos. Sin sorpresas, sin arreglos a escondidas, sin dudas.",
    ],
    quote: "La mayoría de las empresas de limpieza te piden que confíes en ellas. Nosotros preferimos mostrártelo.",
  },
};

export const PhotoReportSection = ({ lang = "en", background = "#FFFFFF", testid = "photo-report-section" }) => {
  const ref = useScrollReveal();
  const copy = COPY[lang];
  return (
    <section ref={ref} data-testid={testid} className="py-20 md:py-28 section-hidden" style={{ background }} lang={lang}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <SectionBadge>{copy.badge}</SectionBadge>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 leading-tight" style={{ fontFamily: FONT_HEAD, color: NAVY }} data-testid={`${testid}-title`}>
              {copy.title}
            </h2>
            {copy.body.map((p) => (
              <p key={p.slice(0, 24)} className="text-base mb-5 leading-relaxed" style={{ color: "#6B7280", fontFamily: FONT_BODY }}>
                {p}
              </p>
            ))}
          </div>
          <div className="lg:col-span-5 lg:pt-12">
            <div className="p-8" style={{ background: NAVY, borderLeft: `4px solid ${GOLD}` }}>
              <div className="w-12 h-12 flex items-center justify-center mb-5" style={{ background: "rgba(212,168,67,0.15)", borderRadius: "2px" }}>
                <Camera size={22} style={{ color: GOLD }} />
              </div>
              <p className="text-lg italic leading-relaxed" style={{ color: "rgba(255,255,255,0.92)", fontFamily: FONT_BODY }} data-testid={`${testid}-quote`}>
                "{copy.quote}"
              </p>
              <p className="text-xs mt-4 font-bold tracking-wider" style={{ color: GOLD, fontFamily: FONT_HEAD }}>
                — Cindyrella Cleaning LLC
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
